import { render } from "./programmer-vue.vue?vue&type=template&id=8c39d352&scoped=true"
import script from "./programmer-vue.vue?vue&type=script&lang=js"
export * from "./programmer-vue.vue?vue&type=script&lang=js"

import "./programmer-vue.vue?vue&type=style&index=0&id=8c39d352&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c39d352"]])

export default __exports__